import { mapCategoryToColor, mapCategoryToIcon } from '@/utils/categoryUtils';
import { cn } from '@/utils/tailwind';

import Constants from '@/constants';

import { CategoryComplianceSquare } from '@/icons';

interface PlanCardCategoryIconProps {
  category?: string;
  disabled?: boolean;
  /**
   * This is a special case for showing a
   * different icon for compliance plans in a disabled state.
   */
  disabledCompliance?: boolean;
  /** Sets opacity to `0.2`. Set for archive/unarchived style. */
  dimmed?: boolean;
}

const PlanCardCategoryIcon: React.FC<PlanCardCategoryIconProps> = ({
  category = Constants.PLAN_CATEGORIES.GENERAL,
  disabled = false,
  disabledCompliance = false,
  dimmed = false,
}) => (
  <div
    className={cn(
      'flex h-auto max-h-screen w-20 shrink-0 items-center justify-center self-auto rounded-l-[inherit]',
      dimmed && 'opacity-20',
    )}
    style={{
      background: disabled
        ? 'var(--color-grayscale-gray3)'
        : mapCategoryToColor(category),
    }}
  >
    {disabledCompliance ? (
      <CategoryComplianceSquare />
    ) : (
      mapCategoryToIcon(category)
    )}
  </div>
);

export default PlanCardCategoryIcon;
